import { Box, Button, Typography } from "@mui/material"

import ModalBox from "../../ModalBox"
import { BoxModal } from "../styled"
import { CloseButton } from "../../styled"

const BalanceIndicatorModal = ({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) => (
  <ModalBox open={open} onClose={onClose}>
    <Box sx={BoxModal}>
      <Typography variant="h3" sx={{ mb: 4 }}>
        Не удалось обновить баланс
      </Typography>
      <Button variant="contained" sx={CloseButton} onClick={onClose}>
        ОК
      </Button>
    </Box>
  </ModalBox>
)

export default BalanceIndicatorModal
